import { render, staticRenderFns } from "./program-keyword-view.vue?vue&type=template&id=6befd6d7&"
import script from "./program-keyword-view.vue?vue&type=script&lang=js&"
export * from "./program-keyword-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports